module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bmjIM"))).then(() => parcelRequire('d0iPb'));